<template>
	<div class="login">

		<div class="g-content">
			<div class="login-head">
				<div>
					<div class="cu-custom" style="height: 45px;">

						<div class="cu-bar fixed bg-gradual-black" style="height: 45px; padding-top: 0px;">
							<div class="action" onclick="history.go(-1)">
								<div style="width: 50px;"><span><img src="@/assets/home/32.png" alt="" /></span></div>
							</div>
							<div class="content text-gold" style="top: 0px;">{{ $t("wangjimima") }}</div>
						</div>
					</div>
				</div>
				<img src="@/assets/home/31.png" class="app-logo" alt="" />
				<div style=" margin-top: 23px; margin-left: 35px;"><span
						style=" font-size: 21px;  color: #b8a78a;">Forex Gold USA</span></div>
			</div>
			<van-cell-group class="login-body van-cell-group">
				<van-field :placeholder="$t('plusername')" v-model="username" clearable>
					<template #left-icon>
						<img src="@/assets/home/33.png" class="left-form-icon" alt="" />
					</template>
				</van-field>
				<div class="field-container">
					<van-field clearable :placeholder="$t('plpassword')" type="password" v-model="password">
						<template #left-icon>
							<img src="@/assets/home/36.png" class="left-form-icon" alt="" />
						</template>
					</van-field>
					<!-- <div class="action"><button class="cu-btn round qblack shadow">
							<div class="cuIcon-commandfill"><span></span></div>Send code
						</button></div> -->
				</div>
				<div class="denglu">
					<button type="primary" round block class="Btnlogin" @click="changeHome">{{ $t("tijiao") }}</button>
				</div>

			</van-cell-group>
		</div>

	</div>
</template>

<script>
	// @ is an alias to /src
	import loginApi from "@/api/login";
	import storeAction from "@/store/typed-actions";

	export default {
		name: "forget",
		components: {

		},
		data() {
			return {

				checked: true,
				username: "",
				password: "",
				PopAlert: false,

			};
		},
		methods: {
			changeRegister() {
				this.$router.push({
					path: "/register",
				});
			},
			changeHome() {
				if (!this.username) {
					this.$toast(this.$t('plusername'));
				} else if (!this.password) {
					this.$toast(this.$t('plpassword'));
				} else {
					if (this.checked) {
						this.setCookie(this.username, this.password, 14);
					} else {
						this.setCookie("", "", -1);
					}
					loginApi
						.login(this.username, this.password)
						.then((data) => {
							console.log(data.data, this.$t('Tips.dlcg'));
							storeAction.loginDone(data.data);
						})
						.catch((err) => {
							this.$toast.clear();
							this.$toast.fail(err.msg);
						});
				}
			},

			showAletfalse() {
				this.PopAlert = false;
			},
		},
		created() {

		},
	};
</script>
<style lang="less" scoped>
	.shadow {
		box-shadow: 3px 3px 4px rgba(26, 26, 26, .2);
	}

	.qblack {
		position: relative;
		display: block;
		margin-left: auto;
		margin-right: auto;
		padding-left: 14px;
		padding-right: 14px;
		box-sizing: border-box;
		font-size: 18px;
		text-align: center;
		text-decoration: none;
		line-height: 2.55555556;
		border-radius: 5px;
		-webkit-tap-highlight-color: transparent;
		overflow: hidden;
		color: #000;
		background-color: #f8f8f8;
		cursor: pointer;
	}

	.cu-btn {
		position: absolute;
		border: 0px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 15px;
		font-size: 14px;
		height: 32px;
		line-height: 1;
		text-align: center;
		text-decoration: none;
		overflow: visible;
		margin-left: 430px;
		margin-bottom: 47px;
		transform: translate(0px, 0px);

	}

	.field-container {
		position: relative;
		width: 100%;
	}

	.action:first-child>div[class*="cuIcon-"] {
		font-family: cuIcon;
		font-size: inherit;
		font-style: normal;
		margin-left: -.3em;
		margin-right: .3em;
	}

	.action {
		display: flex;
		align-items: center;
		height: 100%;
		justify-content: center;
		max-width: 4%;
		margin-left: 15px;
	}

	.container {
		margin-top: 20px;
		margin-left: 52px;
		display: flex;
		justify-content: space-between;
		width: 65%;
	}

	.denglu {
		margin-left: 25px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 85%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 45px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;

		background-color: unset;
	}

	::v-deep .van-button--primary {
		color: #b8a78a;
	}

	::v-deep .van-field__control {

		color: #b8a78a;
	}

	::v-deep .van-field__control::placeholder {
		color: rgb(184, 167, 138);
	}

	.cu-bar {
		display: flex;
		position: relative;
		align-items: center;
		min-height: 52px;
		justify-content: space-between;
	}

	.cu-custom .cu-bar .content {
		width: calc(100% - 228px);
	}

	.cu-bar .content {
		position: absolute;
		text-align: center;
		width: calc(100% - 176px);
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		margin: auto;
		height: 31px;
		font-size: 16px;
		line-height: 31px;
		cursor: none;
		pointer-events: none;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	.cu-custom .cu-bar {
		min-height: 0;
		box-shadow: 0px 0px 0px;
		z-index: 9999;
	}

	.bg-gradual-black {
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		color: #b8a78a;
	}

	.cu-custom {
		display: block;
		position: relative;
	}

	.login {
		display: flex;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		flex-direction: column;
	}

	.close-btn {
		position: absolute;
		padding: 0.3rem;
		z-index: 1;
	}

	.icon-x {
		display: inline-block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		line-height: 0;
		font-size: 0;
		vertical-align: middle;
		transform: rotate(45deg);
	}

	.icon-x::after {
		content: "";
		display: block;
		width: 0.5rem;
		height: 0.07rem;
		background: #fff;
		transform: rotate(-90deg);
	}

	.g-content {
		flex: 1;
		//   overflow: scroll;
	}

	.login-head {
		position: relative;
		height: 4.9rem;
	}

	.app-logo {
		width: 1.3rem;
		height: 1.3rem;
		border-radius: 0.1rem;
		-o-object-fit: cover;
		/* object-fit: cover; */
		/* position: absolute; */
		left: 50%;
		bottom: 0;
		transform: translate(-180%, 120%);
	}

	.login-body {
		margin-top: 0.7rem;
		padding: 0 0.68rem;
	}

	.van-cell-group {
		background: unset;
		position: unset;

		input {}
	}

	.van-cell {
		margin-left: 25px;
		background-image: linear-gradient(45deg, #191a1a, #8799a3);
		position: relative;
		box-sizing: border-box;
		width: 85%;
		padding: 10px 16px;
		overflow: hidden;
		color: unset;
		margin-top: 18px;
		font-size: 14px;
		line-height: 24px;
		border-radius: 30px;
		border: 2px solid #b8a78a;
		background-color: unset;
	}

	.van-field::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 1px solid #3d5179 !important;
		-webkit-transform: scaleY(0.5);
		transform: scaleY(0.5);
	}

	.left-form-icon {
		width: 20px;
	}

	.c_a0a0a0 {
		color: #a0a0a0;
		font-size: 14px;
	}

	.Btnlogin {
		margin-left: 115px;
		color: #b8a78a;
		height: 26px;
	}

	.TxtBtn {
		color: #f37b1d;
		font-size: 14px;
	}

	.content {
		// display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.open-visitor {
		justify-content: space-around;
	}

	.app-version {
		text-align: center;
		margin-top: 0.4rem;
		color: #a0a0a0;
	}

	.van-cell::after {
		position: absolute;
		box-sizing: border-box;
		content: " ";
		pointer-events: none;
		right: 16px;
		bottom: 0;
		left: 16px;
		border-bottom: 0px solid #3d5179;
	}
</style>